import apiFetch from '../apiFetch'

export default function (body, financingId, token) {
  return apiFetch({ endPoint: 'FinanceCompany/' + financingId, method: 'PUT', body: body, token: token })
}
